import React, { Component } from 'react'
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import { AllocationActions, UserSelectionActions, ThirdPartyActions, DealSheetActions } from 'actionsets'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import FormMixin from 'containers/shared/FormMixin'
import ErrorObject from 'containers/shared/ErrorObject'
import { withRouter }              from 'react-router'
import { User } from 'containers'
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button'
import AddIcon from '@material-ui/icons/Add'
import TickIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import { WordDivider, ConditionalRender } from 'components'
import DeleteIcon from '@material-ui/icons/Delete'
import IconButton from '@material-ui/core/IconButton'
import { Authorization } from 'utils'
import BigNumber from 'bignumber.js'
import moment from 'moment-timezone'

export class Form extends FormMixin(Component){

  static initialState = {
    commissions: {
      additions: {},
      removals: {},
    },
    error: '',
    commission: {
      adding: false,
      errors: {
        rate: '',
        thirdParty: ''
      },
      rate: '',
      thirdParty: {}
    },
    attributes: {}
  }

  static ErrorObject = class extends ErrorObject{
    errorAliases = {'organisationCommission.coinPercentage': ['organisationCommission'], 'organisationCommission.tokenPercentage': ['organisationCommission']}

    aliasesFor = fieldName =>
      [fieldName].concat(this.errorAliases[fieldName] || [])

    hasError(fieldName){
      let hasError = super.hasError.bind(this)
      return this.aliasesFor(fieldName).find(fieldName => hasError(fieldName))
    }

    getError(fieldName){
      return super.getError(this.hasError(fieldName))
    }
  }

  constructor(props){
    super(props)
    AllocationActions.bindActions(this)
    UserSelectionActions.bindActions(this, 'userSelect')
    ThirdPartyActions.bindActions(this, 'thirdParties')
    DealSheetActions.bindActions(this, 'dealSheets')
    this.errorObject = new Form.ErrorObject(this)
    this.state       = {...Form.initialState }
  }

  componentDidMount = () => {
    if (this.editMode && !this.props.editAllocationIds.length) {
      this.props.history.push(`/deal_sheets/${this.dealSheetId}/allocations/new`)
    }

    if (!this.attribute('timezone')) {
      this.setState({
        attributes: {
          ...this.state.attributes,
          timezone: this.props.dealSheet.timezone || moment.tz.guess()
        }
      })
    }
  }

  dependsOn(){
    if(!Authorization.admin){
      this.props.history.replace(this.onSaveRoute)
    }
    return this.actions.dealSheets.show({id: this.dealSheetId})
  }

  dependenciesMet(){
    return true
  }

  set onSaveRoute(_){}

  get onSaveRoute(){
    return `/deal_sheets/${this.dealSheetId}/allocations`
  }

  get dealSheetId(){
    return this.props.match.params.id
  }

  get formObject(){
    return this.props.bulkParams || {dealSheetId: this.dealSheetId, thirdPartyCommissions: []}
  }

  get createMode(){
    return !!this.props.match.path.match(/\/new/)
  }

  get ticker(){
    return this.props.dealSheet.ticker
  }

  get currencyCode(){
    return this.props.dealSheet.currency.code
  }

  get editorCountText() {
    return this.createMode ? `Creating ${this.props.newInvestorIds.length} allocations` : `Editing ${this.props.editAllocationIds.length} allocations`
  }

  get updatedFormObject(){
    const updatedFormObject = {}
    const { rate, amount, startDate, endDate, timezone, organisationCommission: { coinPercentage, tokenPercentage } = {} } = super.updatedFormObject
    Object.entries({
      rate,
      amount,
      startDate,
      endDate,
      timezone,
      organisationCommission: {
        coinPercentage, tokenPercentage
      },
      commissions: {
        additions: Object.values(this.state.commissions.additions).map(({thirdParty: {id: thirdPartyId}, coinPercentage, tokenPercentage}) => {return {thirdPartyId, coinPercentage, tokenPercentage}}),
        removals: Object.keys(this.state.commissions.removals).map(thirdPartyId => {return {thirdPartyId}})
      },
      dealSheetId: this.dealSheetId,
      ids:         this.createMode ? this.props.newInvestorIds : this.props.editAllocationIds
    }).forEach(([key, value]) => {
      if([undefined,null, ""].indexOf(value) === -1){
        updatedFormObject[key] = value
      }
    })

    return updatedFormObject
  }

  get saveActionName() {
    return this.createMode ? 'bulkInsert' : 'bulkUpdate'
  }

  get formObjectName(){
    return 'Allocations'
  }

  get commissions(){
    return this.formObject
               .thirdPartyCommissions
               .filter(({thirdParty: { id }}) => !this.state.commissions.removals[id])
               .filter(({thirdParty: { id }}) => !this.state.commissions.additions[id])
               .concat(Object.values(this.state.commissions.additions))
  }

  get commissionErrors(){
    let errors = {}
    let {thirdParty, coinPercentage, tokenPercentage} = this.state.commission
    if (!thirdParty.id)
      errors.thirdParty = 'You must select a third party'
    if (coinPercentage && (isNaN(coinPercentage) || coinPercentage <= 0 || coinPercentage >= 100))
      errors.coinPercentage = 'Commission must be a valid percentage (greater than 0 and less than 100)'
    if (tokenPercentage && (isNaN(tokenPercentage) || tokenPercentage <= 0 || tokenPercentage >= 100))
      errors.tokenPercentage = 'Commission must be a valid percentage (greater than 0 and less than 100)'
    if (!coinPercentage && !tokenPercentage)
      errors.coinPercentage = errors.tokenPercentage = `Commission in ${this.currencyCode} or ${this.ticker} must be provided`
    return (Object.keys(errors).length > 0 ? errors : false)
  }

  get coinValueLabel(){
    if(!this.attribute('amount') || !this.attribute('rate'))
      return ''
    const [amount, rate] = [new BigNumber(this.attribute('amount')), new BigNumber(this.attribute('rate'))]
    return `${amount.div(rate).round(16).toString()} ${this.currencyCode}`
  }

  getLabels(defaultLabel, attributeName){
    const attribute = this.deepGet(attributeName, this.formObject)
    if(!attribute && this.props.bulkParams && this.props.editAllocationIds.length > 1){
      return { label: defaultLabel, helperText: this.getError(attributeName) || <small className={styles.warningText}>Warning: Values for {defaultLabel} are not shared for all selected allocations</small> }
    }else{
      return {label: defaultLabel, helperText: this.getError(attributeName) || ''}
    }
  }

  handleSelectInvestors =  async () => {
    if (this.createMode) {
      const userIds = await this.actions.userSelect.makeSelection({
        title: 'Create Allocations For:',
        actionName: 'Allocate'
      })
      this.actions.setNewInvestorIds({ids: userIds, params: this.props.bulkParams})
    }
  }

  handleEditCommission = () =>
    this.setState({commission:{...Form.initialState.commission, adding: true}})

  handleStopEditCommission = () =>
    this.setState({commission:{...Form.initialState.commission, adding: false}})

  handleSelectThirdParty = ({target: { value: thirdParty }}) =>
    this.setState({commission: {...this.state.commission, thirdParty: thirdParty || {} }})

  handleEnterCoinPercentage = ({target: { value: coinPercentage }})  =>
    this.setState({commission: {...this.state.commission, coinPercentage}})

  handleEnterTokenPercentage = ({target: { value: tokenPercentage }})  =>
    this.setState({commission: {...this.state.commission, tokenPercentage}})

  handleAddCommission = () => {
    return new Promise((resolve, reject) => {
      const errors = this.commissionErrors
      if(errors){
        this.setState({commission: {...this.state.commission, errors }}, reject)
      }else{
        const { thirdParty, coinPercentage, tokenPercentage } = this.state.commission
        const { removals: {[thirdParty.id]: removed, ...removals}, additions } = this.state.commissions
        this.setState({
          commissions: {
            additions: {...additions, [thirdParty.id]: { thirdParty, coinPercentage, tokenPercentage } },
            removals:  removals,
          },
          commission:{...Form.initialState.commission, adding: false, errors: {}}
        }, resolve)
      }
    })
  }

  handleRemoveCommission = id => () => {
    const { removals, additions: { [id]: removed, ...additions } } = this.state.commissions
    this.setState({
      commissions: {
        additions: additions,
        removals:  {...removals,  [id]: true},
      },
      commission:{...Form.initialState.commission, adding: false, errors: {}}
    })
  }

  provideThirdParties = (query) =>
    this.actions.thirdParties.search(query)

  async save(){
    if(this.createMode && this.props.newInvestorIds.length === 0){
      this.setState({error: 'You must select at least one user to create an allocation for'})
      return
    }
    this.setState({error: undefined})
    if(this.state.commission.adding) {
      await this.handleAddCommission()
      super.save()
    }else{
      super.save()
    }
  }

  renderCommissionRow = ({thirdParty: { id, name: thirdPartyName}, coinPercentage, tokenPercentage }, idx) =>
    <TableRow key={idx}>
      <TableCell>{thirdPartyName}</TableCell>
      <TableCell>{coinPercentage || 0}%</TableCell>
      <TableCell>{tokenPercentage || 0}%</TableCell>
      <TableCell>
        <IconButton onClick={this.handleRemoveCommission(id)}>
          <DeleteIcon/>
        </IconButton>
      </TableCell>
    </TableRow>

  render = () => {
    const { NumberField, TextField, DateTimeField, TimezoneField, AutoSuggest, CardActions, CardContent, Card } = this
    return (
      <div style={{width: '100%'}}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant='h6' className={styles.headline}>{this.createMode ? 'Create allocations' : 'Edit allocations'}</Typography>
          </Toolbar>
        </AppBar>
        <Card className={styles.card}>
          <CardContent>
            <ConditionalRender className={styles.errorText} requires={!!this.state.error} component={Typography} variant='body1'>
              {this.state.error}
            </ConditionalRender>
            <TextField fullWidth value={this.editorCountText} margin="normal" label="Investors" inputRef={rf => rf ? rf.readOnly = true : null} onClick={this.handleSelectInvestors}/>
            <NumberField {...this.getLabels(`Number of Tokens (${this.ticker})`, 'amount')} attribute='amount'/>
            <NumberField {...this.getLabels(`Rate (${this.ticker}/${this.currencyCode})`, 'rate')} attribute='rate'/>
            <TextField disabled label={`Value (${this.currencyCode})`} value={this.coinValueLabel}/>
            <NumberField {...this.getLabels(`Commission (%${this.currencyCode})`, 'organisationCommission.coinPercentage')} attribute='organisationCommission.coinPercentage'/>
            <NumberField {...this.getLabels(`Commission (%${this.ticker})`, 'organisationCommission.tokenPercentage')} attribute='organisationCommission.tokenPercentage'/>
            <TimezoneField {...this.getLabels('Timezone', 'timezone')} attribute="timezone"/>
            <DateTimeField {...this.getLabels('Start Date', 'startDate')} attribute='startDate' timezone={this.attribute('timezone')}/>
            <DateTimeField {...this.getLabels('End Date', 'endDate')} attribute='endDate' timezone={this.attribute('timezone')} defaultTime={'23:59:59'}/>
            {this.createMode &&
              <User.UserSelect selection={this.props.newInvestorIds} prefilters={{access_level: 'member', account_type: 'investor'}}/>
            }
            <WordDivider word='Edit Commissions'/>
            <ConditionalRender className={styles.warningText} requires={!!this.formObject.thirdPartyCommissions.hiddenCommissions} component={Typography} variant='body1'>
              Warning – Some commissions which are not shared between the selected allocations are not displayed here.
            </ConditionalRender>
            <div className={styles.commissions}>
              <Table className={styles.commissionsTable} >
                <TableHead>
                  <TableRow>
                    <TableCell>Third Party</TableCell>
                    <TableCell>{this.currencyCode}</TableCell>
                    <TableCell>{this.ticker}</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.commissions.map(this.renderCommissionRow)}
                </TableBody>
              </Table>
              <ConditionalRender requires={!this.state.commission.adding} component={Button} className={styles.addCommissionButton} variant='fab' color='primary' onClick={this.handleEditCommission}>
                <AddIcon/>
              </ConditionalRender>
              <ConditionalRender requires={this.state.commission.adding} component={'div'} className={styles.editCommissionsContainer}>
                <AutoSuggest
                  autoFocus
                  className={styles.thirdPartySelect}
                  onSuggestionsFetchRequested={this.provideThirdParties}
                  labelProvider={({name}) => name || ''}
                  placeholder='Select Third Party'
                  value={this.state.commission.thirdParty.name || ''}
                  onChange={this.handleSelectThirdParty}
                  error={!!this.state.commission.errors.thirdParty}
                  helperText={this.state.commission.errors.thirdParty}
                />
                <NumberField
                  label={`Enter Commission (%${this.currencyCode})`}
                  value={this.state.commission.coinPercentage}
                  onChange={this.handleEnterCoinPercentage}
                  error={!!this.state.commission.errors.coinPercentage}
                  helperText={this.state.commission.errors.coinPercentage}
                />
                <NumberField
                  label={`Enter Commission (%${this.ticker})`}
                  value={this.state.commission.tokenPercentage}
                  onChange={this.handleEnterTokenPercentage}
                  error={!!this.state.commission.errors.tokenPercentage}
                  helperText={this.state.commission.errors.tokenPercentage}
                />
                <Button className={styles.editButton} onClick={this.handleStopEditCommission}>
                  <CloseIcon/>
                </Button>
                <Button className={styles.editButton} onClick={this.handleAddCommission}>
                  <TickIcon/>
                </Button>
              </ConditionalRender>
            </div>
          </CardContent>
          <CardActions className={styles.actions}>
            <Button onClick={() => this.props.history.push(this.onSaveRoute)} className={styles.save} >Cancel</Button>
            <Button onClick={this.save} className={styles.save} variant='contained' color='primary'>Save</Button>
          </CardActions>
        </Card>
      </div>
    )
  }

}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  errorText: {
    color: 'red',
    fontWeight: 'bold'
  },
  warningText: {
    color: '#f5d37b'
  },
  commissions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap-reverse'
  },
  commissionsTable: {
    flex: 1,
    tableLayout: 'fixed',
    '& td': {
      width: 0,
      padding: 0
    },
    '& th': {
      padding: 0
    },
    '& td:nth-child(1)': {
      width: 'auto'
    },
    '@media(max-width: 500px)':{
      '& th': {
        width: 75,
        padding: 0
      },
      '& th:nth-child(1)': {
        width: 'auto'
      }
    }
  },
  addCommissionButton: {
    flex: '0 0 auto'
  },
  editCommissionsContainer: {
    justifyContent: 'flex-end',
    flexDirection: 'row',
    display: 'flex',
    flexWrap: 'wrap'
  },
  editButton: {
    flex: '0 0 auto'
  },
  thirdPartySelect: {
    flex: 1
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column'
  },
  card: {
    flex: '0 1',
    alignSelf: 'flex-start',
    margin: '0px auto',
    minWidth: 300,
    maxWidth: 900
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
})

export default connect(({allocations, dealSheets: { dealSheet }}) => { return {...allocations, dealSheet} })(withRouter(Dependent({loader: true, wrapperClassName: styles.wrapper})(Form)))